

export default {
  name: "pageIcons",
  nickname: "pageIcons",
  desc:
    '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
  type: "object",
  props: {
    horizontal: {
      name: "horizontal",
      nickname: "horizontal",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.orient">legend.orient</a> 为 <code class="codespan">&#39;horizontal&#39;</code> 时的翻页按钮图标。',
    },
    vertical: {
      name: "vertical",
      nickname: "vertical",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.orient">legend.orient</a> 为 <code class="codespan">&#39;vertical&#39;</code> 时的翻页按钮图标。',
    },
  },
}
